import React from 'react';
// import AppContext from "../../AppContext";
import FeaturedCard from './FeaturedCard';
import SideCard from './SideCard';


const NBAEditorial = ({items}) => {
  const normalizedItems = Array.isArray(items) ? items.slice(0, 4) : [];
  const [featured, ...rest] = normalizedItems;

  // if (normalizedItems.length < 4) return null;

  return (
    <section className="w-full px-4 pb-4 sm:px-6 lg:px-10 xl:px-12">
      <div className="mx-auto max-w-7xl  bg-[#ffffff] p-3 sm:pt-6 sm:px-6 sm:pb-1 lg:pt-7 lg:px-7 lg:pb-1">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-7">
            <FeaturedCard item={featured} />
          </div>

          <div className="grid grid-cols-1 gap-4 lg:col-span-5">
            {rest.map((item, index) => (
              <SideCard
                key={`${item.header}-${index}-${item.linkUrl}`}
                item={item}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
  
export default NBAEditorial;